import React, {lazy, Suspense} from "react";
import { withApollo } from "react-apollo";
import { Route, Switch } from "react-router-dom";

import "./App.css";
import Landing from "./pages/Landing";
//import Dashboard from "./pages/Dashboard";
//import ValidateStripeAccount from "./components/stripeConnect/ValidateStripeAccount";
//import UserValidation from "./components/authentication/UserValidation";
//import Checkout from "./components/checkout/Checkout";
//import PrivateRoute from "./components/common/PrivateRoute";
import ErrorBoundary from "./components/common/ErrorBoundary";
import NotFound from "./components/common/NotFound";


const PrivateRoute = lazy(() => import('./components/common/PrivateRoute'))
const Dashboard = lazy(() => import('./pages/Dashboard'))
const ValidateStripeAccount = lazy(() => import('./components/stripeConnect/ValidateStripeAccount'))
const UserValidation = lazy(() => import('./components/authentication/UserValidation'))
const Checkout = lazy(() => import('./components/checkout/Checkout'))

const App = () => {
  return (
      <ErrorBoundary>
        <Suspense fallback={<div></div>}>

        <Switch>
          {/* Landing page */}
          <Route exact component={Landing} path="/" />
          {/* Callback for Stripe account creation to validate the account */}
          <Route
            exact
            component={ValidateStripeAccount}
            path="/account/validate"
          />
          {/* If account exist/validated successfiully we load the dashboard */}
          <PrivateRoute exact path="/dashboard" component={Dashboard} />
          <Route
            exact
            component={UserValidation}
            path="/verify_account/:emailValidationToken"
          />
          <Route exact component={Checkout} path="/checkout/:id" />
          <Route path="*" component={NotFound} />
        </Switch>
        </Suspense>
      </ErrorBoundary>
  );
};

export default withApollo(App);
